import { Injectable } from '@angular/core';
import { ApiOutcomeService } from '../api-services/scene-outcome.api.service';
import { Outcome } from '../models/outcomes/Outcome';
import { ValidationService } from './validation.service';
import { LoadingController } from '@ionic/angular';
import { OutcomeGroupOutcomeRelation } from '../models/outcomes/OutcomeGroupOutcomeRelation';
import { MessagesService } from './messages.service';

@Injectable({
  providedIn: 'root'
})
export class OutcomeGroupsService {
  public loading: any;
  constructor(
    public outcomeApiService: ApiOutcomeService,
    public validationService: ValidationService,
    public loadingController: LoadingController,
    public messagesService: MessagesService,
  ) { }

  async UpdateSubOutcomes(selected: OutcomeGroupOutcomeRelation[], toRemove: OutcomeGroupOutcomeRelation[]) {

    if (selected.length != 0) {
      await this.messagesService.presentLoadingWindow('Adding new sub outcomes...');
      await this.addOutcomesToGroup(selected).then(x => {
        this.messagesService.loadingWindow.dismiss();
      }

      )
    }
    if (toRemove.length != 0) {
      await this.messagesService.presentLoadingWindow('Removing existing sub outcomes...');
      await this.removeOutcomesFromGroup(toRemove).then(x => {
        this.messagesService.loadingWindow.dismiss();
      })
    }
    //this.loading.dismiss();
  }

  async addOutcomesToGroup(selected: OutcomeGroupOutcomeRelation[]) {
    return new Promise<void>((resolve) => {
      this.outcomeApiService.addOutcomesToGroup(selected).subscribe(res1 => {
        resolve();
      });
    });
  }

  async removeOutcomesFromGroup(toRemove: OutcomeGroupOutcomeRelation[]) {
    return new Promise<void>((resolve) => {
      this.outcomeApiService.removeOutcomesOnGroup(toRemove).subscribe(res1 => {
        resolve();
      });
    });
  }

  async addNewOutcomeWithGroup(outcome, outcomeGroupId) {
    await this.messagesService.presentLoadingWindow('Adding Sub Outcome...');
    return new Promise<void>((resolve) => {
      this.outcomeApiService.addOutcome(outcome).subscribe(res => {
        var outcomeGroup = {} as OutcomeGroupOutcomeRelation;
        outcomeGroup.outcomeGroupOutcomeRelationId = 0;
        outcomeGroup.outcomeId = res.outcomeId;
        outcomeGroup.outcomeGroupId = outcomeGroupId;
        this.outcomeApiService.addOutcomeToGroup(outcomeGroup).subscribe(res1 => {
          this.messagesService.loadingWindow.dismiss();
          resolve();
        });
      });
    });
  }


}
